
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcSequenceItem as ObcSequenceItemElement} from '@oicl/openbridge-webcomponents/dist/components/sequence-item/sequence-item.js';
 
 
 

 
 export const ObcSequenceItem = createComponent({
   react: React,
   tagName: 'obc-sequence-item',
   elementClass: ObcSequenceItemElement,
   events: {
     
   }
  });
 
 